import React from 'react'
import { Flex, Box, Button, useDisclosure } from '@chakra-ui/react'
import { useProperty } from 'api/property'
import { useGetVendor } from 'api/wo-estimates'
import { BiAddToQueue } from 'react-icons/bi'
import AddNewEstimateModal from './add-new-estimate-modal'
import { WOEstimatesTable } from './wo-estimates-table'
import { useTrades } from 'api/vendor-details'

interface Props {
  projectData: any
  tabsContainerRef: any
  projectId: string
  onClose: any
  workOrder: any
}
export const WOEstimatesTab: React.FC<Props> = ({ projectData, tabsContainerRef, onClose, projectId, workOrder }) => {
  const { isOpen: isOpenEstimateModal, onClose: onEstimateModalClose, onOpen: onEstimateModalOpen } = useDisclosure()

  const { data: vendorTrades } = useTrades();
  

  
  const propertyId = projectData?.propertyId as any;
  
  const { propertyData } = useProperty(propertyId)

  const { vendorData } = useGetVendor(workOrder?.vendorId)

  const [selectedEstimateId, setSelectedEstimateId] = React.useState<number | null>(null)

  const setEstimateIdOpenModal = (id: number) => {
    setSelectedEstimateId(id)
    onEstimateModalOpen()
  }
  const onModalClose = () => {
    setSelectedEstimateId(null)
    onEstimateModalClose()
  }

  return (
    <>
      <Box h="625px" p="10px" overflow={'auto'}>
        <Flex w="100%" alignContent="space-between" pos="relative">
          <Box w="100%" display="flex" justifyContent={{ base: 'center', sm: 'end' }} position="relative" p="11px">
            <Button
              variant="solid"
              colorScheme="brand"
              onClick={onEstimateModalOpen}
              leftIcon={<BiAddToQueue />}
              mt="-5px"
              isDisabled={workOrder.statusLabel === 'Cancelled'}
            >
              New Estimate
            </Button>
          </Box>
        </Flex>

        <Box>
          <WOEstimatesTable
            ref={tabsContainerRef}
            workOrderId={workOrder.id}
            projectId={projectId}
            setSelectedEstimateId={setEstimateIdOpenModal}
          />
        </Box>
      </Box>

      <AddNewEstimateModal
        isOpen={isOpenEstimateModal}
        onClose={onModalClose}
        projectData={projectData}
        currentWorkOrder={workOrder}
        property={propertyData}
        vendor={vendorData}
        selectedEstimateId={selectedEstimateId}
        vendorTrades={vendorTrades}
      />
    </>
  )
}
